export default {
    obtenerTipoCita(vm) {
        vm.axios.post(`${vm.domain.domainNameForApi}ControldeCitas/ObtenerTipoCita`).then(response => {
           vm.tipoCita.opcionesCita = response.data;
        })
    },

    validarCita(vm) {
        var formData = new FormData();
        formData.append("nrreporte", vm.nrreporte);
        formData.append("svindice", vm.svindice);
        formData.append("cifhcitaini", vm.fechaInicio1);
        formData.append("cifhcitafin", vm.fechaFin1);
        return vm.axios.post(`${vm.domain.domainNameForApi}ControldeCitas/ValidarCita`, formData).then(response => response.data)

    },

    guardarCita(vm) {
        var formData = new FormData();
        formData.append("nrreporte", vm.nrreporte);
        formData.append("svindice", vm.svindice);
        formData.append("cifhcitaini", vm.fechaInicio1);
        formData.append("cifhcitafin", vm.fechaFin1);
        formData.append("tipo", vm.tipoCita.tpcclave.tpcclave);
        formData.append("comentarios", vm.comentarios);
        return vm.axios.post(`${vm.domain.domainNameForApi}ControldeCitas/GuardarCita`, formData).then(response => response.data)

    },

    obtenerHistorialCitas(vm) {
        var formData = new FormData();
        formData.append("nrreporte", vm.nrreporte);
        formData.append("svindice", vm.svindice);
        return vm.axios.post(`${vm.domain.domainNameForApi}ControldeCitas/ObtenerHistorialCitas`, formData).then(response => response.data)
        
    },
    obtenerdataEditar(vm) {
        var formData = new FormData();
        formData.append("ciid", vm.ciid);
        return vm.axios.post(`${vm.domain.domainNameForApi}ControldeCitas/ObtenerdataEditar`, formData).then(response => response.data)

    },

    obtenerFechaActual(vm) {
        var formData = new FormData();
        return vm.axios.post(`${vm.domain.domainNameForApi}ControldeCitas/ObtenerFechaActual`, formData).then(response => response.data)

    },
    validarCitaEditar(vm) {
        var formData = new FormData();
        formData.append("nrreporte", vm.nrreporte);
        formData.append("svindice", vm.svindice);
        formData.append("cifhcitaini", vm.fechaInicio1);
        formData.append("cifhcitafin", vm.fechaFin1);
        formData.append("ciid", vm.ciid);
        return vm.axios.post(`${vm.domain.domainNameForApi}ControldeCitas/ValidarCitaEditar`, formData).then(response => response.data)

    },

    guardarEdicionCita(vm) {
        var formData = new FormData();
        formData.append("cifhcitaini", vm.fechaInicio1);
        formData.append("cifhcitafin", vm.fechaFin1);
        formData.append("tipo", vm.tipoCita.tpcclave.tpcclave);
        formData.append("comentarios", vm.comentarios);
        formData.append("ciid", vm.ciid);
        return vm.axios.post(`${vm.domain.domainNameForApi}ControldeCitas/GuardarEdicionCita`, formData).then(response => response.data)

    },

    obtenerCitaEn(vm) {
        var formData = new FormData();
        formData.append("ciid", vm.ciid);
        vm.axios.post(`${vm.domain.domainNameForApi}ControldeCitas/ObtenerCitaEn`, formData).then(response => {
            
            vm.citaEn.opcionesCitaEn = response.data;
        })
    },

    obtenerConceptosCierre(vm) {
        var formData = new FormData();
        formData.append("tipo", vm.citaEn.cetipo.cetipo);
        vm.axios.post(`${vm.domain.domainNameForApi}ControldeCitas/ObtenerConceptosCierre`, formData).then(response => {
            vm.conceptos.opcionesConceptosCierre = response.data;
        })
    },

    guardarCerrarCita(vm) {
        var formData = new FormData();
        formData.append("nrreporte", vm.nrreporte);
        formData.append("svindice", vm.svindice);
        formData.append("ciid", vm.ciid);
        formData.append("comentarios", vm.comentarios); 
        formData.append("concepto", vm.conceptos.ceclave.ceclave);
        return vm.axios.post(`${vm.domain.domainNameForApi}ControldeCitas/GuardarCerrarCita`, formData).then(response => response.data)

    }, 
    guardarCancelarCita(vm) {
        var formData = new FormData();
        formData.append("ciid", vm.ciid);
        formData.append("comentarios", vm.comentarios);
        return vm.axios.post(`${vm.domain.domainNameForApi}ControldeCitas/GuardarCancelarCita`, formData).then(response => response.data)

    },
    obtenerdataCitaDetalle(vm) {
        var formData = new FormData();
        formData.append("ciid", vm.ciid);
        return vm.axios.post(`${vm.domain.domainNameForApi}ControldeCitas/ObtenerdataCitaDetalle`, formData).then(response => response.data)

    },


    obtenervalConclusion(vm) {
        var formData = new FormData();
        formData.append("nrreporte", vm.nrreporte);
        formData.append("svindice", vm.svindice);
        vm.axios.post(`${vm.domain.domainNameForApi}ControldeCitas/ValidarConclusion`, formData).then(response => {
        
            vm.valConc = response.data;
        })
    },

}